import { useCallback, useEffect, useState } from "react";
import { useLoaderData } from "react-router-dom";

import { useHistoryNavigate } from "../../../../../../hooks/useHistoryNavigate";
import useService from "../../../../../../hooks/useService";
import ApiRequestErrorHandler from "../../../../../global/ApiRequestErrorHandler";
import ResponseModal from "../../../../../global/ResponseModal";
import Svg from "../../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../../ui library/HNSColors";
import { useFollowUpCallLogger } from "../../../hooks/useFollowUpCallLogger";

import ActionButtons from "./ActionButtons";

const Title = ({
  formHeader: formHeaderProp,
  caseId: caseIdProp,
  actionItem: actionItemProp,
  followUpId: followUpIdProp,
  hideActions = false,
  onDocumentUpdated,
}) => {
  const loaderData = useLoaderData() || {};
  const followUp = loaderData.followUp;
  const caseId = caseIdProp ?? loaderData.caseId;
  const actionItem = actionItemProp ?? loaderData.actionItem;
  const followUpId = followUpIdProp ?? loaderData.followUpId;
  const formHeader = formHeaderProp ?? followUp?.formHeader;
  const { sessionId } = useFollowUpCallLogger(followUpId);
  const { historyNavigate } = useHistoryNavigate();
  const actionableItemsRepository = useService("repositories/actionable-items-repository");
  const providerRepository = useService("repositories/provider-repository");
  const [errorMessage, setErrorMessage] = useState([]);
  const [openError, setOpenError] = useState(false);

  useEffect(() => {
    if (hideActions) {
      return undefined;
    }

    let active = true;
    const onCallActive = async () => {
      try {
        await actionableItemsRepository.associateCall(followUpId, sessionId);
      } catch (error) {
        const errArr = ApiRequestErrorHandler(error);
        setErrorMessage(errArr);
        setOpenError(true);
      }
    };

    if (active && sessionId && followUpId) {
      onCallActive();
    }

    return () => {
      //when component unmounts make sure listener is removed
      active = false;
    };
  }, [followUpId, sessionId, hideActions]);

  const dialClient = useCallback((number) => {
    if (!number) {
      return;
    }

    const root = document.querySelector(".Adapter_root");
    if (root?.classList.contains("Adapter_minimized")) {
      document.querySelector(".Adapter_toggle")?.click();
    }

    document.querySelector("#rc-widget-adapter-frame")?.contentWindow.postMessage(
      {
        type: "rc-adapter-new-call",
        phoneNumber: number,
        toDial: false,
        conversation: false,
      },
      "*"
    );
  }, []);

  /* ──────────────────────────────── JSX ────────────────────────────────────── */
  return (
    <>
      <header
        style={{
          background: `linear-gradient(
            91.64deg,
            ${HNSColors.primary[300]} -2.29%,
            ${HNSColors.primary[400]} 24.1%,
            ${HNSColors.primary[500]} 46.74%,
            ${HNSColors.tertiary[500]} 89.2%,
            ${HNSColors.tertiary[700]} 102.56%
          )`,
          boxShadow: `0px 3px 45px 0px ${HNSColors.tertiary[900]}`,
        }}
        className="mb-8 mt-2 flex w-full items-center justify-between gap-2 rounded-[12px] p-4 text-white"
      >
        <div className="flex min-w-[255px] items-center gap-2">
          <Svg
            name={formHeader?.icon ?? "his-info"}
            color={HNSColors.neutrals[900]}
            sx={{ width: "1.5rem" }}
          />
          <h2 className="text-2xl font-semibold">{formHeader?.action_type_label ?? "Follow Up"}</h2>
        </div>

        {!hideActions && (
          <div className="flex gap-2 justify-self-end">
            <ActionButtons
              formHeader={formHeader}
              caseId={caseId}
              actionItem={actionItem}
              historyNavigate={historyNavigate}
              providerRepository={providerRepository}
              dialClient={dialClient}
              setErrorMessage={setErrorMessage}
              setOpenError={setOpenError}
              onDocumentUpdated={onDocumentUpdated}
            />
            <ResponseModal
              title={`associate_call`}
              isError={true}
              openBool={openError}
              setOpenBool={setOpenError}
              errorMessage={errorMessage}
            />
          </div>
        )}
      </header>
    </>
  );
};

export default Title;
